import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import Logo from '../Logo';
import { APP_VERSION } from '../../version';
import '../../styles/admin.css';

import { ta } from '../../i18n/adminT';
import AdminLanguageSelect from './AdminLanguageSelect';
export default function SupervisorPanel({ me, onLogout, onLanguageChange }) {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [resettingId, setResettingId] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.getSupervisorAdmins();
      setAdmins(res.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleReset = async (admin) => {
    if (!window.confirm(
      `Resettare la verifica in due passaggi di "${admin.username}"?\n\n` +
      `Al prossimo accesso dovrà configurarla di nuovo da zero con un nuovo QR code.`
    )) return;

    setError('');
    setSuccessMsg('');
    setResettingId(admin.id);
    try {
      await api.resetAdmin2fa(admin.id);
      setSuccessMsg(`2FA resettata per "${admin.username}". Al prossimo accesso dovrà riconfigurarla.`);
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setResettingId(null);
    }
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="sidebar-logo"><Logo size={32} /></div>
        <div className="admin-nav-item" style={{ cursor: 'default', color: 'var(--paper)' }}>
          {ta('Reset verifica a due passaggi')}
        </div>
        <div className="admin-nav-spacer" />
        <div style={{ color: 'rgba(246,245,241,0.5)', fontSize: '0.78rem', padding: '0 14px 8px', fontFamily: 'var(--font-mono)' }}>
          {me.username} {ta('· supervisor')}
        </div>
        <AdminLanguageSelect value={me.language || 'it'} onChange={onLanguageChange} />
        <button className="admin-nav-item" onClick={onLogout}>{ta('Esci')}</button>
        <div style={{ color: 'rgba(246,245,241,0.3)', fontSize: '0.68rem', padding: '10px 14px 0', fontFamily: 'var(--font-mono)' }}>
          {ta('ExelFlow v')}{APP_VERSION}
        </div>
      </aside>

      <main className="admin-main">
        <h1 className="admin-page-title">{ta('Reset verifica in due passaggi')}</h1>
        <p className="admin-page-subtitle">
          {ta('Usa questa funzione solo se un amministratore ha perso l\'accesso al proprio dispositivo (app authenticator) e non ha salvato un codice di backup. Dopo il reset, all\'accesso successivo dovrà configurare una nuova 2FA da zero.')}
        </p>

        {error && <div className="form-error">{error}</div>}
        {successMsg && (
          <div style={{ background: 'rgba(62,142,126,0.12)', color: 'var(--teal-green-dark)', borderRadius: 'var(--radius-control)', padding: '10px 14px', fontSize: '0.85rem', marginBottom: 16 }}>
            {successMsg}
          </div>
        )}

        <div className="admin-card">
          <table className="admin-table">
            <thead>
              <tr>
                <th>{ta('Username')}</th>
                <th>{ta('Email')}</th>
                <th>{ta('2FA')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {!loading && admins.map((a) => (
                <tr key={a.id}>
                  <td>{a.username}</td>
                  <td>{a.email}</td>
                  <td><span className={`badge-pill badge-pill--${a.totp_enabled ? 'yes' : 'no'}`}>{a.totp_enabled ? ta('Attiva') : ta('Da configurare')}</span></td>
                  <td>
                    <button
                      className="btn-ghost btn"
                      style={{ width: 'auto', padding: '6px 10px' }}
                      onClick={() => handleReset(a)}
                      disabled={resettingId === a.id || !a.totp_enabled}
                      title={!a.totp_enabled ? ta('Questo amministratore non ha ancora configurato la 2FA') : ''}
                    >
                      {resettingId === a.id ? ta('Reset in corso…') : ta('Resetta 2FA')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!loading && admins.length === 0 && <p style={{ color: 'var(--muted-text)', padding: '16px 0 0' }}>{ta('Nessun amministratore trovato.')}</p>}
          {loading && <p style={{ color: 'var(--muted-text)', padding: '16px 0 0' }}>{ta('Caricamento…')}</p>}
        </div>
      </main>
    </div>
  );
}
